import React from "react";
import { Spinner } from "react-bootstrap";
import "../assets/Styling/customstyle.css";

export const ButtonLoader = (props) => {
  const { show, width, height } = props;

  if (!show) return null;

  const spinnerStyle =
    width || height
      ? {
          width: width,
          height: height,
        }
      : {};

  return (
    <div className={`buttonloader ${show ? "" : "show"}`}>
      {show ? (
        <Spinner
          animation="border"
          className="spinner-border"
          role="status"
          style={spinnerStyle}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      ) : null}
    </div>
  );
};
